// Custom JS Application Code

/* textarea autosize: https://github.com/jackmoore/autosize */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e||self).autosize=t()}(this,function(){var e,t,n="function"==typeof Map?new Map:(e=[],t=[],{has:function(t){return e.indexOf(t)>-1},get:function(n){return t[e.indexOf(n)]},set:function(n,o){-1===e.indexOf(n)&&(e.push(n),t.push(o))},delete:function(n){var o=e.indexOf(n);o>-1&&(e.splice(o,1),t.splice(o,1))}}),o=function(e){return new Event(e,{bubbles:!0})};try{new Event("test")}catch(e){o=function(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!1),t}}function r(e){var t=n.get(e);t&&t.destroy()}function i(e){var t=n.get(e);t&&t.update()}var l=null;return"undefined"==typeof window||"function"!=typeof window.getComputedStyle?((l=function(e){return e}).destroy=function(e){return e},l.update=function(e){return e}):((l=function(e,t){return e&&Array.prototype.forEach.call(e.length?e:[e],function(e){return function(e){if(e&&e.nodeName&&"TEXTAREA"===e.nodeName&&!n.has(e)){var t,r=null,i=null,l=null,d=function(){e.clientWidth!==i&&c()},u=function(t){window.removeEventListener("resize",d,!1),e.removeEventListener("input",c,!1),e.removeEventListener("keyup",c,!1),e.removeEventListener("autosize:destroy",u,!1),e.removeEventListener("autosize:update",c,!1),Object.keys(t).forEach(function(n){e.style[n]=t[n]}),n.delete(e)}.bind(e,{height:e.style.height,resize:e.style.resize,overflowY:e.style.overflowY,overflowX:e.style.overflowX,wordWrap:e.style.wordWrap});e.addEventListener("autosize:destroy",u,!1),"onpropertychange"in e&&"oninput"in e&&e.addEventListener("keyup",c,!1),window.addEventListener("resize",d,!1),e.addEventListener("input",c,!1),e.addEventListener("autosize:update",c,!1),e.style.overflowX="hidden",e.style.wordWrap="break-word",n.set(e,{destroy:u,update:c}),"vertical"===(t=window.getComputedStyle(e,null)).resize?e.style.resize="none":"both"===t.resize&&(e.style.resize="horizontal"),r="content-box"===t.boxSizing?-(parseFloat(t.paddingTop)+parseFloat(t.paddingBottom)):parseFloat(t.borderTopWidth)+parseFloat(t.borderBottomWidth),isNaN(r)&&(r=0),c()}function a(t){var n=e.style.width;e.style.width="0px",e.style.width=n,e.style.overflowY=t}function s(){if(0!==e.scrollHeight){var t=function(e){for(var t=[];e&&e.parentNode&&e.parentNode instanceof Element;)e.parentNode.scrollTop&&t.push({node:e.parentNode,scrollTop:e.parentNode.scrollTop}),e=e.parentNode;return t}(e),n=document.documentElement&&document.documentElement.scrollTop;e.style.height="",e.style.height=e.scrollHeight+r+"px",i=e.clientWidth,t.forEach(function(e){e.node.scrollTop=e.scrollTop}),n&&(document.documentElement.scrollTop=n)}}function c(){s();var t=Math.round(parseFloat(e.style.height)),n=window.getComputedStyle(e,null),r="content-box"===n.boxSizing?Math.round(parseFloat(n.height)):e.offsetHeight;if(r<t?"hidden"===n.overflowY&&(a("scroll"),s(),r="content-box"===n.boxSizing?Math.round(parseFloat(window.getComputedStyle(e,null).height)):e.offsetHeight):"hidden"!==n.overflowY&&(a("hidden"),s(),r="content-box"===n.boxSizing?Math.round(parseFloat(window.getComputedStyle(e,null).height)):e.offsetHeight),l!==r){l=r;var i=o("autosize:resized");try{e.dispatchEvent(i)}catch(e){}}}}(e)}),e}).destroy=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],r),e},l.update=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],i),e}),l});

class CustomCursorDrag {
	constructor(options = {}) {
		this.cursorId = options.cursorId || 'custom-cursor-drag';
		this.targetSelector = options.targetSelector || '.swiper-wrapper';
		this.breakpoint = options.breakpoint || 1025;

		this.cursor = document.getElementById(this.cursorId);
		this.targets = document.querySelectorAll(this.targetSelector);

		if (!this.cursor || !this.targets.length) return;

		this.init();
	}

	init() {
		document.addEventListener('mousemove', this.followCursor.bind(this));

		this.targets.forEach((el) => {
			el.addEventListener('mouseenter', this.onEnter.bind(this));
			el.addEventListener('mouseleave', this.onLeave.bind(this));
			el.addEventListener('mouseover', this.checkLinkHover.bind(this));
			el.addEventListener('mouseout', this.checkLinkHover.bind(this));
		});

		window.addEventListener('resize', this.onResize.bind(this));
	}


	followCursor(e) {
		this.cursor.style.left = `${e.clientX}px`;
		this.cursor.style.top = `${e.clientY}px`;
	}

	onEnter() {
		if (this.isLargeScreen()) {
			this.cursor.classList.add('visible');
			this.togglePointer(true);
		}
	}

	onLeave() {
		this.cursor.classList.remove('visible');
		this.togglePointer(false);
	}

	onResize() {
		if (!this.isLargeScreen()) {
			this.cursor.classList.remove('visible');
			this.togglePointer(false);
		}
	}

	isLargeScreen() {
		return window.innerWidth > this.breakpoint;
	}

	togglePointer(hide) {
		document.body.classList.toggle('hide-cursor', hide);
	}

	checkLinkHover(e) {
		if (e.target.closest('a')) {
			this.cursor.classList.remove('visible');
			this.togglePointer(false);
		} else if (this.isLargeScreen() && e.currentTarget.contains(e.target)) {
			this.cursor.classList.add('visible');
			this.togglePointer(true);
		}
	}
}


function checkHeaderOffset() {
	var $window = jQuery(window);
	var offset = $window.scrollTop();
	if (offset>=30) {
		jQuery('#headerWrapper').addClass('scrolled');
	}else{
		jQuery('#headerWrapper').removeClass('scrolled');
	}
}

function windowOnResize() {
	var myWidth, myHeight;
	if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
	browserWidth = myWidth;
	browserHeight = myHeight;
}
function pageScroll() {
	checkHeaderOffset();
}

function scrollToSlide(slideTo) {
	jQuery('body,html').animate({ scrollTop: jQuery('.'+slideTo).offset().top-jQuery('header').height() }, 800);
}

window.addEventListener('DOMContentLoaded', (event) => {
	(function($) {
		"use strict"; // Start of use strict
		$(window).bind('hashchange');
		$(window).trigger('hashchange');
		$(window).scroll( function() { pageScroll(); } );
		$(window).resize(function() { windowOnResize(); });

		var myWidth, myHeight;
		if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
		browserWidth = myWidth;
		browserHeight = myHeight;

		//if ($(window).width()>=1024) { new WOW().init(); }

		//$('.go-top a').click(function () { $('body,html').animate({ scrollTop: 0 }, 800); $(this).blur(); return false; });

		$('.footer-nav').each(function() {
			const links = $(this).find('ul');
			if (links.length === 1) {
				$(this).addClass('--have-submenu');
				$(this).find('.nav-title').append('<svg><use xlink:href="#icon-arrow-down"></use></svg>');
			}
		});

		$('.footer-nav.--have-submenu .nav-title').bind('click',function(ev) {
			if (browserWidth<=1024) {
				const $parent = $(this).parent('.footer-nav');
				if ($parent.hasClass('--expanded')) {
					$parent.removeClass('--expanded');
					$parent.find('ul').slideUp(300);
				} else {
					$parent.addClass('--expanded');
					$parent.find('ul').slideDown(300);
				}
				$(this).blur(); ev.preventDefault();
			}
		});

		$('.js-nav-toggle').bind('click',function(ev) {
			$('#headerWrapper').toggleClass('--opened');

			$(this).blur();
			ev.preventDefault();
		});

		$('.js-langs-toggle').bind('click',function(ev) {
			const parent = $(this).closest('.languages-wrapper');
			parent.toggleClass('--opened');

			$(this).blur(); ev.preventDefault();
		});

		$('.accordion-toggle a').bind('click',function(ev) {
			const accordion = $(this).closest('.accordion-item').toggleClass('--opened');
			accordion.find('.accordion-content').slideToggle(300);
			$(this).toggleClass('--is-active');

			$(this).blur(); ev.preventDefault();
		});

		$('.category-item').each(function() {
			const links = $(this).find('ul');
			if (links.length >= 1) {
				$(this).addClass('--have-submenu');
				$(this).find('.category-link').append('<svg><use xlink:href="#icon-arrow-down"></use></svg>');
			}
		});
		$('.subcategories-list > li > a').each(function() {
			const links = $(this).closest('li').find('ul');
			if (links.length === 1) {
				$(this).closest('li').addClass('--have-submenu');
				$(this).append('<svg><use xlink:href="#icon-arrow-down"></use></svg>');
			}
		});

		// $('.category-item.--have-submenu .category-link').bind('click',function(ev) {
		// 	const $parent = $(this).parent('.category-item');
		// 	if ($parent.hasClass('--expanded')) {
		// 		$parent.removeClass('--expanded');
		// 		$parent.find('> ul').slideUp(0);
		// 	} else {
		// 		$parent.addClass('--expanded');
		// 		$parent.find('> ul').slideDown(0);
		// 	}
		// 	$(this).blur(); ev.preventDefault();
		// });

		// $('.subcategories-list > li.--have-submenu > a').bind('click',function(ev) {
		// 	const $parent = $(this).parent('li');
		// 	if ($parent.hasClass('--expanded')) {
		// 		$parent.removeClass('--expanded');
		// 		$parent.find('> ul').slideUp(0);
		// 	} else {
		// 		$parent.addClass('--expanded');
		// 		$parent.find('> ul').slideDown(0);
		// 	}
		// 	$(this).blur(); ev.preventDefault();
		// });

		$('.js-open-product-categories').bind('click',function(ev) {
			const parent = $(this).closest('.m-product-categories');
			parent.find('.categories-wrapper').addClass('--opened');
			$(this).blur(); ev.preventDefault();
		});

		$('.js-close-product-categories').bind('click',function(ev) {
			const parent = $(this).closest('.categories-wrapper');
			parent.removeClass('--opened');
			$(this).blur(); ev.preventDefault();
		});

		/* FORM FUNCTIONS */
		autosize($('textarea'));

		$('.js-form-submit').bind('click',function(ev) {
			var form = $(this).closest('form');
			form.find('.wpcf7-submit').click();
			$(this).blur(); ev.preventDefault();
		});

		$('.m-form input[type="checkbox"]').change(function() {
			var cbName = $(this).attr("name");
			if(this.checked) {
				$(this).closest('.wpcf7-list-item').addClass('is-checked');
				if (cbName=='acceptance') {
					$(this).closest('.m-form').find('.js-form-submit').removeClass('--disabled');
				}
			}else{
				$(this).closest('.wpcf7-list-item').removeClass('is-checked');
				if (cbName=='acceptance') {
					$(this).closest('.m-form').find('.js-form-submit').addClass('--disabled');
				}
			}
		});

		/* Video Popup */
		$('.js-open-video-popup').bind('click',function(ev) {
			var videoType = $(this).data('video-type');
			var videoUrl = $(this).data('video-url');
			if (videoType=='youtube') {
				const iframe = document.createElement('iframe');
				//var videoId = videoUrl.split('v=')[1];
				//console.log(videoUrl);

				//if (videoId.indexOf('&') > -1) { videoId = videoId.split('&')[0]; }
				//iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;
				iframe.src = videoUrl + (videoUrl.indexOf('?') > -1 ? '&' : '') + 'autoplay=1&rel=0&showinfo=0&controls=1';
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('allow', 'autoplay; encrypted-media');
				iframe.setAttribute('allowfullscreen', '');
				$('.m-popup-video-wrapper .video-wrapper').append(iframe);
			} else {
				// Is MP4
				const video = document.createElement('video');
				video.src = videoUrl;
				video.setAttribute('controls', true);
				video.setAttribute('autoplay', true);
				video.setAttribute('muted', '');
				video.setAttribute('loop', '');
				video.setAttribute('playsinline', true);
				video.setAttribute('preload', 'auto');
				$('.m-popup-video-wrapper .video-wrapper').append(video);
			}

			$('.popup-video-bg-layer').addClass('--opened');
			$('.m-popup-video-wrapper').addClass('--opened');

			$(this).blur(); ev.preventDefault();
		});

		$('.m-popup-video-wrapper').bind('click',function(ev) {
			$('.popup-video-bg-layer').removeClass('--opened');
			$('.m-popup-video-wrapper').removeClass('--opened');
			setTimeout(() => {
				$('.m-popup-video-wrapper .video-wrapper').empty();
			}, 400); // 400ms = 0.4s


			$(this).blur(); ev.preventDefault();
		});

		$('.js-search-submit').bind('click',function(ev) {
			$(this).closest('form').submit();
			$(this).blur(); ev.preventDefault();
		});


		$(window).on('load',function() {

			new CustomCursorDrag({
				cursorId: 'custom-cursor-drag',
				targetSelector: '.--custom-cursor-drag',
				breakpoint: 1025
			});


			if ($('.m-banner').length) {
				$('.m-banner').each(function() {
					new Swiper('.m-banner .swiper-container', {
						spaceBetween: 0,
						loop: true,
						freeMode: false,
						effect: 'fade',
						slidesPerView: 1,
						autoplay: {
							delay: 3000,
							disableOnInteraction: false,
						},
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
						}
					});
				});
			}

			if ($('.m-highlights-news').length) {
				$('.m-highlights-news').each(function() {
					new Swiper('.m-highlights-news .swiper-container', {
						spaceBetween: 16,
						loop: false,
						freeMode: true,
						slidesPerView: 'auto',
						breakpoints: {
							1025: {
								spaceBetween: 18
							}
						},
					});
				});
			}

			if ($('.expertise-finishes').length) {
				$('.expertise-finishes').each(function() {
					new Swiper('.expertise-finishes .swiper-container', {
						spaceBetween: 24,
						loop: false,
						freeMode: true,
						slidesPerView: 'auto',
						breakpoints: {
							768: {
								spaceBetween: 16
							},
							1025: {
								spaceBetween: 14
							}
						},
					});
				});
			}

			if ($('.about-us-products').length) {
				$('.about-us-products').each(function() {
					new Swiper('.about-us-products .swiper-container', {
						spaceBetween: 24,
						loop: true,
						freeMode: false,
						slidesPerView: 1,
						effect: 'fade',
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
						},
						breakpoints: {
							768: {
								spaceBetween: 16
							},
							1025: {
								spaceBetween: 14
							}
						},
					});
				});
			}

			if ($('.about-us-content-sliders .content-item').length) {
				$('.about-us-content-sliders .content-item').each(function() {
					const id = $(this).attr('id');

					new Swiper('#'+id+' .swiper-container', {
						spaceBetween: 16,
						loop: true,
						freeMode: false,
						slidesPerView: 1,
						forceToAxis: true,
						direction: 'vertical',
						//mousewheel: true,
						autoplay: {
							delay: 3000,
							disableOnInteraction: false,
						},
						breakpoints: {
							768: {
								spaceBetween: 24
							},
							1025: {
								spaceBetween: 24
							}
						},
					});
				});
			}

			if ($('#productGallery').length) {
				var thumbsSwiper = new Swiper("#productGalleryThumbs", {
					//loop: true,
					spaceBetween: 10,
					slidesPerView: 4,
					//freeMode: true,
					watchSlidesProgress: true,
					breakpoints: {
						1025: {
							spaceBetween: 16
						}
					},
				  });
				  var swiper2 = new Swiper("#productGallery", {
					loop: true,
					spaceBetween: 10,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					thumbs: {
					  swiper: thumbsSwiper,
					  //autoScrollOffset: 1,
					},
				  });
			}

			if ($('.b-gallery').length) {
				$('.b-gallery').each(function() {
					const slider = $(this).find('.swiper-container')[0];
					const pagination = $(this).find('.swiper-pagination')[0];
					const slidesCount = Number($(this).data('slides-count'));

					const pauseInactiveVideos = () => {
						slider.querySelectorAll('video').forEach((video) => {
							if (!video.closest('.swiper-slide-active')) video.pause();
						});
					};

					const swiper = new Swiper(slider, {
						loop: slidesCount > 1,
						spaceBetween: 0,
						slidesPerView: 1,
						noSwipingSelector: 'video',
						autoplay: slidesCount > 1 ? {
							delay: 5000,
							disableOnInteraction: true,
						} : false,
						pagination: pagination ? {
							el: pagination,
							clickable: true,
						} : undefined,
						on: {
							slideChange: pauseInactiveVideos,
						},
					});

					if (slidesCount > 1) {
						const stopAutoplay = () => {
							if (swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
						};

						slider.tabIndex = 0;
						slider.addEventListener('pointerdown', stopAutoplay, true);
						slider.addEventListener('touchstart', stopAutoplay, true);
						slider.addEventListener('keydown', (event) => {
							stopAutoplay();
							if (event.target !== slider) return;
							if (event.key === 'ArrowLeft') {
								event.preventDefault();
								swiper.slidePrev();
							} else if (event.key === 'ArrowRight') {
								event.preventDefault();
								swiper.slideNext();
							}
						});
						slider.querySelectorAll('video').forEach((video) => {
							video.addEventListener('play', stopAutoplay);
						});
					}
				});
			}

			if ($('.m-related-products').length) {
				$('.m-related-products').each(function() {
					new Swiper('.m-related-products .swiper-container', {
						spaceBetween: 16,
						loop: false,
						freeMode: true,
						slidesPerView: 'auto'
					});
				});
			}

			if ($('.hp-products').length) {
				$('.hp-products').each(function() {
					new Swiper('.hp-products .swiper-container', {
						spaceBetween: 16,
						loop: false,
						freeMode: true,
						slidesPerView: 'auto'
					});
				});
			}

		});

	})(jQuery); // End of use strict
});

window.addEventListener('DOMContentLoaded', (event) => {
	gsap.registerPlugin(ScrollTrigger);

	/*
	smoother = ScrollSmoother.create({
		//normalizeScroll: true,
		smooth: 3,
		effects: true,
		//onUpdate: self => console.log("direction:", self.direction)
	});
	*/
});

window.addEventListener('DOMContentLoaded', (event) => {
	(function($) {
		"use strict"; // Start of use strict
		$(window).on('load',function() {
			ScrollTrigger.matchMedia({
				"(max-width: 767px)": function() {
					if (jQuery('.timeline').length) {
						const blocks = document.querySelectorAll('.timeline-block');

						blocks.forEach((block, index) => {
							ScrollTrigger.create({
								trigger: block,
								start: 'top center',
								toggleActions: 'play none none none', // só ativa uma vez
								toggleClass: { targets: block, className: '--animated' },
								onEnter: () => {}
							});
						});



						// Timeline - linha de preenchimento
						const timeline = document.querySelector('.timeline');
						const fillLine = document.querySelector('.timeline-line-fill');

						ScrollTrigger.create({
							trigger: timeline,
							start: "top bottom",
							end: "bottom 50%",
							scrub: true,
							//markers: true,
							onUpdate: self => {
								const halfHeight = window.innerHeight * 0.5;
								const timelineTop = timeline.offsetTop;
								const scrollY = window.scrollY;
								const point0 = scrollY-timelineTop;
								const distance = point0 + halfHeight + 10;

								gsap.set(fillLine, {
									height: distance
								});
							}
						});
					}

				},
				"(min-width: 768px)": function() {
					document.querySelectorAll('.grid-row').forEach((row, index) => {
						const items = row.querySelectorAll('.item');

						items.forEach((el) => {
							const isImage = el.classList.contains('image');
							const isText = el.classList.contains('text');
							const pos = el.classList.contains('left') ? 'left'
								: el.classList.contains('right') ? 'right'
								: 'center';

							let x = 0, y = 0, opacity = 0;

							// Define animação inicial
							if (isImage) {
								if (pos === 'left') x = -250;
								if (pos === 'right') x = 250;
							}

							if (isText) {
								if (pos === 'left') x = -250;
								if (pos === 'right') x = 250;
								if (pos === 'center') y = -250;
							}

							gsap.from(el, {
								scrollTrigger: {
									trigger: row,
									start: 'top 50%',
									toggleActions: 'play none none none',
								},
								x,
								y,
								opacity,
								duration: 1.5,
								ease: 'power2.out',
							});
						});
					});

					if (jQuery('.timeline').length) {
						const blocks = document.querySelectorAll('.timeline-block');

						blocks.forEach((block, index) => {
							ScrollTrigger.create({
								trigger: block,
								start: 'top center',
								toggleActions: 'play none none none', // só ativa uma vez
								toggleClass: { targets: block, className: '--animated' },
								onEnter: () => {}
							});
						});

						document.querySelectorAll('.timeline-block').forEach(block => {
							const leftContent = block.querySelector('.timeline-content.text');
							const rightContent = block.querySelector('.timeline-content.content');
							const dot = block.querySelector('.timeline-dot');

							if (leftContent && rightContent) {
								const blockHeight = rightContent.scrollHeight;
								const leftContentHeight = leftContent.clientHeight;
								const scrollHeight = blockHeight-leftContentHeight;

								ScrollTrigger.create({
									trigger: block,
									start: 'top center',
									end: `+=${scrollHeight}`,
									pin: leftContent,
									pinSpacing: false,
									scrub: false
								});

								// Pin da bolinha
								ScrollTrigger.create({
									trigger: block,
									start: 'top center',
									end: `+=${scrollHeight}`,
									pin: dot,
									pinSpacing: false,
									scrub: false,
									onLeave: () => {
										// Quando termina o pin, começa a mover a bolinha até ao fim do leftContent
										// const distance = blockHeight - dot.offsetHeight;

										// gsap.to(dot, {
										// 	y: distance,
										// 	duration: 0.6,
										// 	ease: "power2.out"
										// });
									},
									onEnterBack: () => {
										// Se fizer scroll para trás, volta à posição original
										// gsap.to(dot, {
										// 	y: 0,
										// 	duration: 0.3,
										// 	ease: "power2.out"
										// });
									}
								});
							}
						});

						// Timeline - linha de preenchimento
						const timeline = document.querySelector('.timeline');
						const fillLine = document.querySelector('.timeline-line-fill');

						ScrollTrigger.create({
							trigger: timeline,
							start: "top bottom",
							end: "bottom 50%",
							scrub: true,
							//markers: true,
							onUpdate: self => {
								const halfHeight = window.innerHeight * 0.5;
								const timelineTop = timeline.offsetTop;
								const scrollY = window.scrollY;
								const point0 = scrollY-timelineTop;
								const distance = point0 + halfHeight + 10;

								gsap.set(fillLine, {
									height: distance
								});
							}
						});
					}
				},
				"(min-width: 834px)": function() {},
				"(min-width: 1025px)": function() {
					//about-us-content-sliders

					document.querySelectorAll('.about-us-content-sliders .content-item').forEach((item) => {
						const info = item.querySelector('.info');
						const slider = item.querySelector('.slider');
						const isInverted = item.classList.contains('--inverted');

						const infoFromX = isInverted ? 300 : -300;
						const sliderFromX = isInverted ? -300 : 300;

						gsap.from(info, {
							x: infoFromX,
							opacity: 0,
							duration: 1,
							ease: 'power2.out',
							scrollTrigger: {
								trigger: item,
								start: 'top 80%',
								toggleActions: 'play none none none',
							},
						});

						gsap.from(slider, {
							x: sliderFromX,
							opacity: 0,
							duration: 1,
							ease: 'power2.out',
							scrollTrigger: {
								trigger: item,
								start: 'top 80%',
								toggleActions: 'play none none none',
							},
						});
					});

					gsap.from('.about-us-products .images-slider', {
						x: 300, // slide from right
						opacity: 0,
						duration: 1,
						ease: 'power2.out',
						scrollTrigger: {
							trigger: '.about-us-products .images-slider',
							start: 'top 80%',
							toggleActions: 'play none none none',
						},
					});
				},
				"all": function() {

					/* Homepage words loop animation - It worked, but below there is other with more complex features */
					// document.querySelectorAll(".scroll-line").forEach((line, index) => {
					// 	const content = line.querySelector(".scroll-content");
					// 	const direction = index % 2 === 0 ? 1 : -1;

					// 	// Duplicate content for seamless loop
					// 	const clone = content.cloneNode(true);
					// 	line.appendChild(clone);

					// 	// Create timeline
					// 	const totalWidth = content.offsetWidth;

					// 	gsap.fromTo(content,
					// 		{ x: 0 },
					// 		{
					// 			x: direction * -totalWidth,
					// 			duration: 15,
					// 			ease: "none",
					// 			delay: 0*index,
					// 			repeat: -1,
					// 			modifiers: {
					// 				x: gsap.utils.unitize(gsap.utils.wrap(-totalWidth, 0))
					// 			}
					// 		}
					// 	);

					// 	// Apply same animation to the clone, placed next to original
					// 	const clonedContent = line.querySelectorAll(".scroll-content")[1];
					// 	gsap.set(clonedContent, { x: direction * totalWidth });
					// 	gsap.fromTo(clonedContent,
					// 		{ x: direction * totalWidth },
					// 		{
					// 			x: 0,
					// 			duration: 15,
					// 			ease: "none",
					// 			delay: 0*index,
					// 			repeat: -1,
					// 			modifiers: {
					// 				x: gsap.utils.unitize(gsap.utils.wrap(-totalWidth, 0))
					// 			}
					// 		}
					// 	);
					// });

					const lines = document.querySelectorAll(".scroll-line");
					let scrollInfluence = 0;

					const linesPixelsPerSecond = 150;

					// Scroll wheel influencia velocidade
					document.addEventListener("wheel", (e) => {
						scrollInfluence += e.deltaY * 0.0005;
						scrollInfluence = gsap.utils.clamp(-3, 3, scrollInfluence);
					});

					// Aplica animação contínua por linha
					lines.forEach((line, index) => {
						const content = line.querySelector(".scroll-content");
						const direction = index % 2 === 0 ? 1 : -1;

						// Duplicate content for seamless loop
						const clone = content.cloneNode(true);
						line.appendChild(clone);

						// Create timeline
						const totalWidth = content.offsetWidth;

						const linesDuration = totalWidth / linesPixelsPerSecond;

						// Apply same animation to the clone, placed next to original
						const clonedContent = line.querySelectorAll(".scroll-content")[1];
						gsap.set(clonedContent, { x: direction * totalWidth });

						const tl1 = gsap.timeline({ repeat: -1, defaults: { duration: linesDuration, delay: 0*index, ease: "none", modifiers: { x: gsap.utils.unitize(gsap.utils.wrap(-totalWidth, 0)) } } });
						const tl2 = gsap.timeline({ repeat: -1, defaults: { duration: linesDuration, delay: 0*index, ease: "none", modifiers: { x: gsap.utils.unitize(gsap.utils.wrap(-totalWidth, 0)) } } });

						tl1.to(content, { x: direction * -totalWidth } );
						tl2.to(clonedContent, { x: 0 } );

						// skew dinâmico
						const skewSetter = gsap.quickSetter([content, clonedContent], "skewX", "deg");

						gsap.ticker.add(() => {
							tl1.timeScale(1 + scrollInfluence * direction);
							tl2.timeScale(1 + scrollInfluence * direction);
							//skewSetter(scrollInfluence * 500 * direction * -1);
							//skewSetter(scrollInfluence * 250 * direction * -1);
							scrollInfluence *= 0.9; // fricção
						});

						// hover pause
						line.addEventListener("mouseenter", () => { tl1.pause(); tl2.pause(); });
						line.addEventListener("mouseleave", () => { tl1.resume(); tl2.resume(); });
					});


					/* 40 Years - intro - animation */
					if (jQuery('.m-intro-animation').length) {
						const tl = gsap.timeline();
						/*
						const tl = gsap.timeline({
							scrollTrigger: {
								trigger: '.m-intro-animation',
								start: 'top top',
								toggleActions: 'play none none none'
							}
						});
						*/

						tl.to('.intro-logo', { opacity: 1, scale: 1, duration: 1 })
						.to('.intro-logo', { opacity: 0, duration: 1, delay: 1 })
						.to('.intro-text', { opacity: 1, scale: 1, duration: 1 })
						.to('.intro-text span.border', {
							width: '100%', duration: 1, /*ease: 'power2.out',*/
							onUpdate: () => {
								// fallback para browsers que não animam ::after com gsap
								document.querySelector('.line-2').classList.add('underline-animate');
							},
							delay: 0.25
						}, ">"); // começa depois da linha de texto entrar

						tl.play();
					}

					ScrollTrigger.create({
						trigger: '.bottom-info-timeline',
						start: 'top 50%',
						toggleClass: { targets: '.bottom-info-timeline', className: '--in-viewport' },
						//once: true, // optional: only run once,
						toggleActions: 'play none none reverse'
					});

					document.querySelectorAll('video.--autoplay-on-scroll').forEach((video) => {
						ScrollTrigger.create({
							trigger: video,
							start: 'top 80%', // adjust to control when it starts
							end: 'bottom top',
							onEnter: () => {
								video.play().catch((e) => {
									console.warn('Autoplay failed:', e);
								});
							},
							onLeaveBack: () => {
								video.pause();
								video.currentTime = 0; // optional: reset on scroll out
							},
						});
					});

					const backToTopBtn = document.getElementById('back-to-top');

					gsap.set(backToTopBtn, { autoAlpha: 0 }); // start hidden

					ScrollTrigger.create({
						start: 'top+=200 top', // show after 200px scroll
						end: 'bottom bottom',
						onEnter: () => gsap.to(backToTopBtn, { autoAlpha: 1, duration: 0.3 }),
						onLeaveBack: () => gsap.to(backToTopBtn, { autoAlpha: 0, duration: 0.3 })
					});

					backToTopBtn.addEventListener('click', () => {
						//gsap.to(window, { scrollTo: 0, duration: 0.7, ease: 'power2.out' });
						//window.scrollTo({ top: 0, behavior: 'smooth' });
						jQuery('body,html').animate({ scrollTop: 0 }, 800);
					});

				},
			});

		});
	})(jQuery); // End of use strict
});

var browserWidth = 0;
var browserHeight = 0;


/* SEARCH FEATURE */
document.addEventListener('DOMContentLoaded', () => {
	const modal = document.getElementById('search-popup');
	const toggleButtons = document.querySelectorAll('.js-search-toggle');
	const closeBtn = document.getElementById('search-close');
	const input = document.getElementById('search-input');
	const results = document.getElementById('autocomplete-results');

	let debounceTimeout;

	// Open modal
	toggleButtons.forEach(btn => {
		btn.addEventListener('click', () => {
			modal.classList.remove('hidden');
			input.focus();
		});
	});

	// Close modal
	closeBtn.addEventListener('click', () => {
		modal.classList.add('hidden');
		results.innerHTML = '';
		input.value = '';
	});

	// Press ESC to close
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			modal.classList.add('hidden');
			results.innerHTML = '';
			input.value = '';
		}
	});

	// 🧠 Autocomplete logic
	input.addEventListener('input', () => {
		const term = input.value.trim();

		clearTimeout(debounceTimeout);
		results.innerHTML = '';

		if (term.length < 2) return;

		debounceTimeout = setTimeout(() => {
			fetch(js_vars.vars.ajaxurl + `?action=search_autocomplete&term=${encodeURIComponent(term)}`)
				.then(res => res.json())
				.then(data => {
					results.innerHTML = data.map(item =>
						`<li><a href="${item.link}">${item.title}</a></li>`
					).join('');
				});
		}, 300);
	});
});
